export const INITIATE_LOGIN_MUTATION = `
  mutation initiateLogin($username: OfficerUsername, $password: String!, $client: Client!) {
    initiateLogin(username: $username, password: $password, client: $client) {
      __typename,

      ... on TwoFactorAuth {
        type
      },

      ... on AuthenticationData {
        id,
        counties{
          code,
          label,
          value
        },
        accessToken,
        refreshToken
      }

      ... on InvalidUserIdError {
        message
      },

      ... on UserLockedError {
        message
      },

      ... on InvalidPasswordError {
        message
      },

      ... on AccessDenied {
        message
      }
    }
  }
`;
